import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Button } from "@components/ui/button";
import CustomSelect from "@components/common/CustomSelect";
import { toast } from "@components/ui/use-toast";
// import InfoTooltip from "@components/common/InfoTooltip";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { Input } from "@components/ui/input";
import { checkDatalistName } from "./createPluginApi";
import { useQuery } from "react-query";
import PageLoader from "@components/loaders/PageLoader";
import { loadJsonData } from "@services/api/commonApis";

const columnTypeOptions = [
  { label: "Run Once", value: "run_once" },
  { label: "Replace Each Time", value: "replace_each_time" },
  { label: "Make Time series", value: "make_timeseries" },
];
const TYPE_DATA_LIST = [
  { label: "hash", value: "hash" },
  { label: "ip", value: "ip" },
  { label: "domain", value: "domain" },

  { label: "email", value: "email" },
];
type Props = {
  open: boolean;
  handleClose: () => void;
  getParquetFieldsData?: (data: any) => void;
  currentBundleId?: any;
  selectedOption?: string | null;
  pluginId: string | undefined;
};

const ParquetFields: React.FC<Props> = ({
  open,
  handleClose,
  getParquetFieldsData,
  currentBundleId,
  selectedOption,
  pluginId,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState<{
    logUid: string;
    logTitle: string;
    logType: string;
    logCategory: string;
    lsProductType: string[];
    // cronFrequency: string;
    dataListName: string;
    cronType: string;
    typeDatalist: string;
    display_name: string;
  }>({
    logUid: "",
    logTitle: "",
    logType: selectedOption === "saveDataList" ? "datalist" : "parquet",
    logCategory: "",
    // TODO : lsProductType set default to cmx, need to change in future
    lsProductType: ["cmx"],
    // cronFrequency: "",
    dataListName: "",
    cronType: "",
    typeDatalist: "",
    display_name: "",
  });

  const { refetch: refetchDatalistCheck } = useQuery({
    queryKey: ["checkDatalist", formData.dataListName, pluginId],
    queryFn: () => checkDatalistName(formData.dataListName, pluginId || ""),
    enabled: false,
    retry: false,
  });
  const { data: vendorproductdata } = useQuery(["loadJsonData"], () =>
    loadJsonData("/static/ls/json/device-vendor-product-mappingDict.json"),
  );
  // take all types from vendorproductdata keys
  const all_categories = vendorproductdata
    ? Object.keys(vendorproductdata)
        .map((key) => ({ label: key, value: key }))
        .sort((a, b) => a.label.localeCompare(b.label))
    : [];
  // // Function to handle type change
  // const handleTypeChange = (selected: string[]) => {
  //   setFormData({ ...formData, lsProductType: selected });
  // };

  // Function to handle form submission
  const handleSave = async () => {
    setLoading(true);
    const isSaveDataList = selectedOption === "saveDataList";
    if (
      (!isSaveDataList &&
        (!formData.logTitle ||
          !formData.logCategory ||
          formData.lsProductType.length === 0)) ||
      (isSaveDataList &&
        (!formData.cronType ||
          !formData.dataListName ||
          !formData.typeDatalist))
    ) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please fill in all required fields.",
      });
      setLoading(false);
      return;
    }
    if (isSaveDataList) {
      try {
        const res = await refetchDatalistCheck();

        if (res?.data?.exists) {
          toast({
            variant: "destructive",
            title: "Duplicate Data List",
            description: "This data list name already exists.",
          });
          return;
        }
      } catch {
        toast({
          variant: "destructive",
          title: "Validation Failed",
          description: "Unable to validate data list name.",
        });
        setLoading(false);
        return;
      }
    }
    const uid = isSaveDataList
      ? `${formData.dataListName.toLowerCase().replace(/\s+/g, "_")}_${Date.now()}`
      : `${formData.logTitle.toLowerCase().replace(/\s+/g, "_")}_${Date.now()}`;

    const updatedFormData = {
      ...formData,
      logType: isSaveDataList ? "datalist" : "parquet",
      logUid: uid,
      currentBundleId,
    };
    getParquetFieldsData && getParquetFieldsData(updatedFormData);
    handleClose();
    setLoading(false);
  };

  return (
    <>
      {open && (
        <>
          <style>
            {`
              [data-radix-popper-content-wrapper] {
                z-index: 9999 !important;
              }
            `}
          </style>
          <div className="fixed inset-0 bg-modalBackground z-[60]" />
        </>
      )}
      <Dialog open={open} onOpenChange={handleClose} modal={false}>
        <PageLoader show={loading} />
        <DialogContent
          className="sm:max-w-[425px] overflow-visible"
          style={{ zIndex: 65 }}
          onInteractOutside={(event) => {
            event.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle className="border-b pb-2">
              {selectedOption === "saveDataList"
                ? "Save Datalist"
                : "Save Logs"}{" "}
            </DialogTitle>
          </DialogHeader>

          <div className="flex flex-col gap-4 mt-2 border border-secondary rounded-lg p-4">
            {selectedOption === "saveDataList" ? (
              <>
                <div className="flex flex-col text-sm">
                  <label htmlFor="">Data List</label>
                  <Input
                    placeholder="Data List Name"
                    value={formData.dataListName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z0-9_]*$/.test(value)) {
                        setFormData((prev) => ({
                          ...prev,
                          dataListName: value,
                        }));
                      }
                    }}
                    required
                  />
                </div>

                <div className="flex flex-col text-sm">
                  <label className="block" htmlFor="">
                    Cron Type
                  </label>
                  <Select
                    value={formData.cronType || ""}
                    onValueChange={(val) =>
                      setFormData((prev) => ({ ...prev, cronType: val }))
                    }
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select column type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {columnTypeOptions.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex flex-col text-sm">
                  <label className="block" htmlFor="">
                    Group By
                  </label>
                  <Select
                    value={formData.typeDatalist || ""}
                    onValueChange={(val) =>
                      setFormData((prev) => ({ ...prev, typeDatalist: val }))
                    }
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select column type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {TYPE_DATA_LIST.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-col text-sm">
                  <label htmlFor="">Log Name</label>
                  <input
                    type="text"
                    placeholder="Log Name"
                    className="p-2 border border-secondary bg-transparent rounded-md text-sm w-full !focus:outline-foreground "
                    value={formData.logTitle}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        logTitle: e.target.value,
                      }))
                    }
                    required
                  />
                </div>

                <div className="flex flex-col text-sm">
                  <label htmlFor=""> Log Category</label>
                  <CustomSelect
                    data={all_categories}
                    placeholder="Select Save Category"
                    onSelect={(value) =>
                      setFormData({ ...formData, logCategory: value })
                    }
                    defaultValue={
                      formData.logCategory ? [formData.logCategory] : []
                    }
                    multiSelect={false}
                    sorted={true}
                  />
                </div>

                {/* TODO : need this in the future */}

                {/* <CustomSelect
              data={LS_PRODUCT_TYPE}
              placeholder="Select LS product type"
              onSelect={handleTypeChange}
              defaultValue={[]}
              multiSelect
            /> */}

                {/* <div className="flex flex-col text-sm">
                  <div className="flex justify-between items-center">
                    <label htmlFor=""> Execution Frequency</label>
                    <InfoTooltip text="Enter the execution frequency in minutes (e.g., 60)" />
                  </div>
                  <input
                    type="number"
                    placeholder="Execution Frequency"
                    className="p-2 border border-secondary bg-transparent rounded-md text-sm w-full"
                    value={formData.cronFrequency}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        cronFrequency: e.target.value,
                      })
                    }
                    required
                  />
                </div> */}
              </>
            )}

            <div className="flex justify-end gap-2 mt-4">
              <Button variant="outline" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleSave();
                }}
              >
                Save Field Mapping
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ParquetFields;
